import app from "../firebase";
import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions(app, "us-central1");

const callPaymentLinkAction = async (paymentLinkAction, data = {}) => {
  const callable = httpsCallable(functions, "createUser");
  return (await callable({ paymentLinkAction, ...data })).data;
};

export const createPaymentLinksForContacts = async ({
  contactIds,
  messageTemplate,
  sendSms = false,
  linkExpirationMinutes = 10
}) => {
  return callPaymentLinkAction("createForContacts", {
    contactIds,
    messageTemplate,
    sendSms,
    linkExpirationMinutes
  });
};

export const listRecentPaymentLinks = async ({ limit = 30 } = {}) =>
  callPaymentLinkAction("listRecent", { limit });
